<template>
  <div>
    <el-input :clearable="clearable" @clear="clear" :disabled="disabled" @focus="startPick()" v-model="transferTo"></el-input>
    <el-dialog append-to-body :title="title" :visible="showDialog" @close="showDialog = false" width="80%" class="dialog">
      <div class="table">
        <!--=========查询模块================-->
        <div class="container">
          <div class="handle-box">
            <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="130px">
              <el-row v-if="puMulti == true">
                <el-col>
                  <el-form-item :label="$t('sys.userList.userName')" prop="name">
                    <el-input class="handle-input" v-model="transferTo" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="8">
                  <el-form-item label="Category1" prop="categoryLevel1Code">
                    <ic-select disabled table="BASE" filterable field="CATEGORY_LEVEL1" clearable @change="queryCondition.categoryLevel2Code=null,queryCondition.categoryLevel3Code=null" v-model="queryCondition.categoryLevel1Code"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="Category2" prop="categoryLevel2Code">
                    <ic-select table="BASE" filterable clearable :field="queryCondition.categoryLevel1Code" @change="queryCondition.categoryLevel3Code=null" v-model="queryCondition.categoryLevel2Code"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="Category3" prop="categoryLevel3Code">
                    <ic-select :table="queryCondition.categoryLevel1Code" filterable clearable :field="queryCondition.categoryLevel2Code" v-model="queryCondition.categoryLevel3Code"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="8">
                  <el-form-item :label="$t('base.fiveBitCode.title')" prop="fiveBitCode">
                    <el-input class="handle-input" v-model.trim="queryCondition.fiveBitCode" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('base.fiveBitCode.name')" prop="fiveBitCodeName">
                    <el-input class="handle-input" v-model.trim="queryCondition.fiveBitCodeName" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="产品描述" prop="describe">
                    <el-input class="handle-input" v-model="queryCondition.describe" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="center">
                <el-col :span="5">
                  <el-button type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
                  <el-button type="primary" @click="restQueryForm">{{$t('common.reset')}}</el-button>
                  <el-button type="primary" @click="pickUp">{{$t('common.confirm')}}</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <!--=========查询模块END================-->
          <!--=========用户信息数据列表================-->
          <el-table :data="tableData" ref="pickUserTable" row-key="tmUserId" border highlight-current-row @selection-change="selectionChange">
            <el-table-column v-if="puMulti == true" :reserve-selection="true" prop="tmUserId" type="selection" min-width="55" align="center" />
            <el-table-column show-overflow-tooltip v-if="!puMulti" prop="name" :label="$t('common.select')" min-width="50" align="center">
              <template slot-scope="scope">
                <el-radio v-model="selectDataAll" :label="scope.row">{{scope.row.name}}</el-radio>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="categoryLevel1Name" label="Category1" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="categoryLevel2Name" label="Category2" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="categoryLevel3Name" label="Category3" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="fiveBitCode" :label="$t('base.fiveBitCode.title')" min-width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="goTo(scope.row)">{{scope.row.fiveBitCode}}</el-button>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="fiveBitCodeName" label="产品名称" min-width="200"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="describe" label="产品描述" min-width="200"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="templateName" label="模板名称" min-width="200"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="remark" label="备注" min-width="150"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="version" label="版本号" min-width="80"></el-table-column>
          </el-table>
          <div class="pagination">
            <!--===分页组件===-->
            <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
          </div>
        </div>
        <!--=========用户信息数据列表END================-->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { userService } from "@/api/user-manage/user";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import IcSelect from "@/components/common/icSelect";
import dataTableUtils from "@/utils/dataTableUtils";
import fiveBitCode from "@/api/base-data/fiveBitCode";
import { disable } from "@/api/base-data/supplier";
import commonMethods from "@/utils/commonMethods";

export default {
  name: "pickupFiveBitCode",
  components: { IcSelect },
  props: ["value", "title", "multi", "placeholder", "selectDatas", "disabled", "fiveBitCode", "clearable"],
  data() {
    return {
      puMulti: this.multi,
      puPlaceholder: this.placeholder,
      tableData: [],
      selectDataAll: this.multi
        ? {
          defaultData: commonFun.convertToArray(this.fiveBitCode),
          pageDatas: []
        }
        : this.fiveBitCode,
      totalCount: 0,
      labelPosition: "right",
      queryCondition: {
        categoryLevel1Code: '10',
        categoryLevel2Code: '',
        categoryLevel3Code: '',
        fiveBitCode: null,
        fiveBitCodeName: null,
        pageSize: 15,
        pageNum: 1,
        describe: '',
      },
      showDialog: false,
      notSelRoles: [],
      selRoles: [],
      userId: null,
      userInfo: {},
      showUserInfo: false
    };
  },
  computed: {
    getSelectedData() {
      if (this.multi) {
        let selectedData = [];
        let defaultData = this.selectDataAll.defaultData;
        if (commonFun.isNotEmpty(defaultData)) {
          selectedData.push(...defaultData);
        }
        let pageDatas = this.selectDataAll.pageDatas;
        for (let pageData of pageDatas.values()) {
          if (commonFun.isNotEmpty(pageData)) {
            selectedData.push(...pageData);
          }
        }
        return selectedData;
      } else {
        return this.selectDataAll;
      }
    },
    transferTo() {
      if (commonFun.isEmpty(this.getSelectedData)) {
        return null;
      }
      if (this.puMulti) {
        return this.getSelectedData
          .map(fiveBitCode => fiveBitCode.fiveBitCodeName)
          .join(";");
      } else {
        return this.selectDataAll.fiveBitCodeName;
      }
    }
  },
  watch: {
    fiveBitCode(newVal) {
      this.selectDataAll = this.multi
        ? {
          defaultData: commonFun.convertToArray(newVal),
          pageDatas: []
        }
        : newVal;
    }
  },
  methods: {
    // GRI(产品编码)进行可跳转到物料主数据页面
    goTo(row) {
      let resolve = this.$router.resolve({
        path: `/material-master-data?fiveBitCode=${row.fiveBitCode}`
      });
      window.open(resolve.href, "_blank");
    },
    clear() {
      this.selectDataAll = this.multi
        ? {
          defaultData: [],
          pageDatas: []
        }
        : null;
      this.$emit("clear");
      this.$emit("update:fiveBitCode", {});
    },
    startPick() {
      this.showDialog = true;
      this.queryData();
    },
    queryData(val) {
      var that = this;
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      fiveBitCode.query(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
      });
    },
    restQueryForm() {
      this.queryCondition = {
        categoryLevel1Code: '10',
        categoryLevel2Code: '',
        categoryLevel3Code: '',
        fiveBitCode: null,
        fiveBitCodeName: null,
        pageSize: 15,
        pageNum: 1,
        describe: '',
      }
      this.queryData();
    },
    pickUp() {
      if (this.puMulti) {
        this.$emit("input", this.getSelectedData.map(fiveBitCode => fiveBitCode.fiveBitCodeName));
      }
      // else {
      //   this.$emit("input", this.getSelectedData.fiveBitCodeName);
      // }
      console.log('this.getSelectedData', this.getSelectedData)
      this.$emit("pickup", this.getSelectedData);
      this.dispatch('ElFormItem', 'el.form.change', [this.getSelectedData.fiveBitCodeName]);
      this.showDialog = false;
    },
    selectionChange(fiveBitCodes) {
      let that = this;
      let pageNum = that.queryCondition.pageNum;
      this.$set(
        that.selectDataAll.pageDatas,
        pageNum,
        Array.isArray(fiveBitCodes) ? fiveBitCodes : [fiveBitCodes]
      );
    },
  },
  extends: dataTableUtils,
};
</script>
<style scoped  lang="scss">
.el-select {
  width: 100%;
}
.el-table {
  margin-top: 10px;
}
</style>
